module.exports = __webpack_public_path__ + "assets/img/engine.0525b332.png";